
document.addEventListener('DOMContentLoaded', function() {
    // Check if the URL object in local storage exists if not create an empty object.
    const paramsObject = JSON.parse(localStorage.getItem('urlParams')) || {};

    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Save the URL parameters to the object
    urlParams.forEach((value, key) => {
        // Don't update a param if it has a value already.
        if(!paramsObject[key]) {
            paramsObject[key] = value;
        }
    });

    // Save the object to local storage
    localStorage.setItem('urlParams', JSON.stringify(paramsObject));

    if(paramsObject) {
    // Find all Gravity Forms on the page
        const forms = document.querySelectorAll('.gform_wrapper');

        forms.forEach(form => {
            Object.keys(paramsObject).forEach(key => {
                const input = form.querySelector(`[data-field-class="${key}"] input`);
                if(input) {
                    input.value = paramsObject[key];
                }
            });
        });
    }
});

